function triggerLoadBuildAvisReducer(currentState = false, action) {
  switch (action.type) {
    case "TRIGGER_LOADBUILD_AVIS":
      return action.payload;
    default:
      break;
  }
  return currentState;
}

export default triggerLoadBuildAvisReducer;
